import React, { Component } from 'react';
import { connect } from "react-redux";
import { sortArray } from '../assets/util';
import ProfilePic from '../atoms/profilePic/profilePic';
import SideModal from '../molecules/modal/sideModal';
import EmptyState from '../molecules/emptyState/emptyState';
import { ListComments } from '../molecules/listItems/listItems';

class HappinessFollowUp extends Component {
  renderList() {
    const { comments } = this.props;
    if(comments) {
      let commentsArray = Object.keys(comments).map(key => comments[key])
      if(commentsArray.length > 0) {
        let commentsArraySorted = sortArray(commentsArray);
        return commentsArraySorted.map((comment, key) => {
          return <ListComments key={key} comment={comment} />
        })
      }
    } else {
      return <EmptyState title='Follow up on your employee`s happiness!' text='Everyone can update their happiness daily. Suggestions for improvements can be submitted anonymously. Let`s keep this place awesome!' />
    }

  }
  render() {
    const { highFives, state } = this.props
    return (
      <SideModal active={state ? 'active' : null } screen='happinessFollowUp' >
        <div id='sideModalWrapper'>
          <h1>Employee happiness</h1>
          <div className='followUpList'>
            {this.renderList()}
          </div>

        </div>
      </SideModal>
    )
  }
}

function mapStateToProps(state) {
  let happinessComments = null;
  if(state.firestore && state.firestore.data && state.firestore.data.customers && state.firestore.data.customers[state.general.company.customerId]) {
    happinessComments = state.firestore.data.customers[state.general.company.customerId].happinessComments
  }
  return {
    state: state.overlays.happinessFollowUp,
    comments: happinessComments
   }
}

export default connect(mapStateToProps)(HappinessFollowUp);
